<template>
  <div class="container-fluid">
    <div class="row body-row">
      <div class="col-md-3 col-lg-2 p-0 d-md-block bg-dark">
        <nav-main></nav-main>
      </div>
      <div class="col-md-9 ms-sm-auto col-lg-10 pt-3 ">
        <my-breadcrumb></my-breadcrumb>
        <div class="restaurants">
          <div class="row my-3">
              <h2>
                {{ $t('restaurants.title') }}
                <div v-show="this.LOADING.restaurants" class="spinner-border spinner-border-sm h4 fw-normal text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </h2>
          </div>
          <div class="row pb-4">
            <div class="col-auto">
            <router-link to="/restaurant-create" class="btn btn-sm btn-outline-success px-3">{{ $t('restaurants.btnAddRestaurant') }}</router-link>
            </div>
          </div>
          <div class="row">
            <div v-for="rest in this.RESTAURANTS" class="col-6 col-xl-3 col-xxl-2 mb-3">
                <div class="card" @click="openRestaurant(rest.id, rest)">
                  <div class="card__image">
                    <img v-if="rest.src" :src="rest.src" class="card-img-top" :alt="rest.title">
                    <img v-else src="../../assets/img/placeholder.jpg" class="card-img-top" alt="rest.title">
                  </div>
                  <div class="card-body">
                    <h5 class="card-title">{{ rest.title }}</h5>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import router from "@/router";
import NavMain from '../modules/NavMain'
import MyBreadcrumb from '../modules/Breadcrumb'
export default {
  name: "Restaurants",
  components: {NavMain, MyBreadcrumb},
  computed: {
    ...mapGetters([
      'RESTAURANTS',
      'LOADING',
    ])
  },
  methods: {
    openRestaurant(id, rest) {
      this.$store.commit('clearRestaurantItem') // очищаем инфомацию о ресторане в state
      this.$store.commit('clearRestaurantMenuItem') // очищаем меню ресторана в state
      this.$store.commit('clearAllModifiersAndOptions') // очищаем Модификаторы и Опции ресторана в state
      this.$store.commit('clearAllModules') // очищаем Модификаторы и Опции ресторана в state
      this.$store.commit('setRestaurantItem', rest) // записываем информацию об открывающемся ресторане
      router.push({ name: 'RestMenu', params: {id} })
    }
  },
  mounted() {
    this.$store.dispatch('getRestaurants')
  }

}
</script>

<style scoped>

</style>
